module.exports = __webpack_public_path__ + "static/black-background-efe92a94298c1b74b7faca202d98ddd9.jpg";